<form
  *ngIf="!!form && !noForm"
  [formGroup]="form"
>
  <app-input-wrapper
    [title]="title"
    [formControlNameString]="formControlNameString"
    [iconBefore]="iconBefore"
    [iconAfter]="iconAfter"
    [showSpinner]="showSpinner"
    [noForm]="noForm"
  >
    <mat-select
      *ngIf="sortingFunction"
      [formControlName]="formControlNameString"
      appFormControl
      [multiple]="multiple"
    >
      <mat-option
        *ngFor="let choice of choicesMap | keyvalue: sortingFunction"
        [value]="choice.value"
      >
        {{ choice.key }}
      </mat-option>
    </mat-select>
  </app-input-wrapper>
</form>
